<template>
  <v-card class="pb-2">
    <v-card-title>
      <v-row class="portal-deep-blue-bg text-center  mb-3">
        <h4>{{ job.asset }}</h4>
      </v-row>
    </v-card-title>
    <v-card-text v-if="viewMode" class="pt-3">
      <h3 class="my-5">Time based Maintenance</h3>
      <!-- Composant timeline avec slot de personnalisation -->
      <HorizontalTimeline :timelineList="tmEvents" >
        <!-- slot `item` pour customiser chaque événement -->
        <template v-slot:default="slotProps">
          <div class="timeline-item">
            <h5> {{ slotProps.item.title }}</h5>
          </div>
        </template>
      </HorizontalTimeline>
      <h3 class="my-5">KM based Maintenance</h3>
      <!-- Composant timeline avec slot de personnalisation -->
      <HorizontalTimeline :timelineList="kmEvents" >
        <!-- slot `item` pour customiser chaque événement -->
        <template v-slot:default="slotProps">
          <div class="timeline-item">
            <h5> {{ slotProps.item.title }}</h5>
          </div>
        </template>
      </HorizontalTimeline>
    </v-card-text>
    <v-card-text v-if="!viewMode">

      <v-row class="border-inf pb-3">
        <!--Km-based Maintenance (TKM)-->
        <v-col md="6" class="pb-0 pl-0">
          <v-sheet width="100%">
            <h4 class="title2">Km-based Maintenance</h4>
            <v-row v-if="noData(job.tkms)">
              <v-template>
                <job-plan-element :elt="element" title="true" />
              </v-template>

              <v-template v-for="(j, k) in job.tkms" :key="k">
                <job-plan-element :elt="j" class="ml-2" />
              </v-template>
            </v-row>
            <v-row v-else class="noData">
              <v-col class="line">
                <span class="bold">No data feedback</span><br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

        <!--Time-based Maintenance (TKM)-->
        <v-col md="6" class="pb-0 pl-0">
          <v-sheet width="100%">
            <h4 class="title2">Time-based Maintenance </h4>
            <v-row v-if="noData(job.tbms)">
              <v-template>
                <job-plan-element :elt="element" title="true" />
              </v-template>
              <v-template v-for="(j, k) in job.tbms" :key="k">
                <job-plan-element :elt="j" />
              </v-template>
            </v-row>
            <v-row v-else class="noData">
              <v-col class="line">
                <span class="bold">No data feedback</span><br />
              </v-col>
            </v-row>
          </v-sheet>

        </v-col>
      </v-row>

      <!--Train Control System-->
      <v-row class="border-inf">
        <v-sheet width="100%">
          <h4 class="title2">Train Control System</h4>

          <v-row v-if="noData(job.atps)">
            <v-template>
              <job-plan-element :elt="element" title="true" />
            </v-template>
            <v-template v-for="(j, k) in job.atps" :key="k">
              <job-plan-element :elt="j" />
            </v-template>
          </v-row>
          <v-row v-else class="noData">
            <v-col class="line">
              <span class="bold">No data feedback</span><br />
            </v-col>
          </v-row>
        </v-sheet>
      </v-row>


      <v-row class="border-inf pb-3">
        <!--Brake Revisions-->
        <v-col md="8" class="pb-0 pl-0">
          <br-element :job="job"></br-element>
        </v-col>

        <!--Gearbox - Initial Oilchange-->
        <v-col md="4" sm="6" xs="12" class="pb-0 pl-0">
          <v-sheet>
            <h4 class="title2">Gearbox - Initial Oilchange</h4>
            <v-row v-if="noData(job.gearbox)">
              <v-template>
                <job-plan-element :elt="element" title="true" />
              </v-template>
              <job-plan-element :elt="job.gearbox" />
            </v-row>
            <v-row v-else class="noData">
              <v-col class="line">
                <span class="bold">No data feedback</span><br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>

      <v-row class="border-inf pb-3">
        <!--US Check (KM)-->
        <v-col md="3" sm="6" xs="12" class="pb-0 pl-0">
          <v-sheet>
            <h4 class="title2">US Check (KM)</h4>
            <v-row v-if="noData(job.uscheck)">
              <v-template>
                <job-plan-element :elt="element" title="true" />
              </v-template>
              <job-plan-element :elt="job.uscheck" />
            </v-row>
            <v-row v-else class="noData">
              <v-col class="line">
                <span class="bold">No data feedback</span><br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
        <!--Pressure Vessel-->
        <v-col md="6" sm="6" class="pb-0">
          <v-sheet>
            <h4 class="title2">Pressure Vessel</h4>
            <v-row v-if="noData(job.pv)">
              <v-template>
                <job-plan-element :elt="element" title="true" />
              </v-template>
              <v-template v-for="(j, k) in job.pv" :key="k">
                <job-plan-element :elt="j" />
              </v-template>
            </v-row>
            <v-row v-else class="noData">
              <v-col class="line">
                <span class="bold">No data feedback</span><br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
        <!--§32-->
        <v-col md="3" sm="6" class="pb-0">
          <v-sheet>
            <h4 class="title2">§32</h4>
            <v-row v-if="noData(job.ebo)">
              <v-template>
                <job-plan-element :elt="element" title="true" />
              </v-template>
              <job-plan-element :elt="job.ebo" />
            </v-row>
            <v-row v-else class="noData">
              <v-col class="line">
                <span class="bold">No data feedback</span><br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>

      <v-row class="border-inf pb-3">


        <v-col md="5" sm="6" class="pb-0 pl-0">
          <v-sheet>
            <h4 class="title2">Train Radio</h4>
            <v-row v-if="noData(job.radio)">
              <v-template>
                <job-plan-element :elt="element" title="true" />
              </v-template>
              <job-plan-element :elt="job.radio" />
            </v-row>
            <v-row v-else class="noData">
              <v-col class="line">
                <span class="bold">No data feedback</span><br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

        <v-col md="7" sm="6" class="pb-0">
          <v-sheet>
            <h4 class="title2">Fire Extinguisher</h4>
            <v-row v-if="noData(job.fires)">
              <v-template>
                <job-plan-element :elt="element" title="true" />
              </v-template>
              <v-template v-for="(j, k) in job.fires" :key="k">
                <job-plan-element :elt="j" />
              </v-template>
            </v-row>
            <v-row v-else class="noData">
              <v-col class="line">
                <span class="bold">No data feedback</span><br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import JobPlanElement from './JobPlanElement.vue';
import BrElement from '@/components/BrElement'
export default {
  name: "JobPlan",
  props: ["job", "viewMode"],
  data() {
    return {
      element: {
        frequency: "Frequency",
        value: "<b>Remaining</b>",
        nextDate: "Next due date",

      },
      events: [],
      kmEvents: [],
      tmEvents: [],
    }
  },
  components: {
    JobPlanElement,
    BrElement,
  },
  created() {
    this.events = this.formatTimelineData(this.job);
    this.tmEvents = this.filterAndSortTimelineData(this.events);
    this.filterAndSortKmTimelineData(this.events, 0)
  },
  methods: {

    filterAndSortTimelineData(events) {
      return events.filter(event => event.time !== null)
        .sort((a, b) => {
          const timeA = new Date(a.time).getTime();
          const timeB = new Date(b.time).getTime();
          return timeA - timeB;
        });
    },

    filterAndSortKmTimelineData(events) {
      return events.filter(event => event.unit == "MILEAGE")
        .sort((a, b) => {
          return a.value - b.value;
        }).forEach(item => {
          this.kmEvents.push({
            id: item.id,
            title: item.title,
            time: item.value,
            unit: item.unit,
            description: `${item.frequency} ${item.unit} – valeur : ${item.value}`,
            group: item.group             
          });
        });
    },



    formatTimelineData(data) {
      const { asset, actualKm, ...groups } = data;
      const events = [];

      Object.entries(groups).forEach(([groupKey, groupValue]) => {
        if (!groupValue) return;           // on ignore les null / undefined
        // on uniformise en tableau
        const items = Array.isArray(groupValue) ? groupValue : [groupValue];
        items.forEach(item => {
          events.push({
            id: `${asset}-${groupKey}-${item.type}`,
            title: item.type,
            value: actualKm + item.value,
            unit: item.unit,
            time: item.nextDate ? item.nextDate.split('T')[0] : null,
            description: `${item.frequency} ${item.unit} – valeur : ${item.value}`,
            group: groupKey               // utile si vous voulez colorer ou filtrer
          });
        });
      });

      if(events.length == 0){
        events.push({
            id: 1,
            title: "No Data",
            value: 0,
            unit: "MILEAGE",
            time: "No Data",
            description: "No Data",
            group: "No Data"               
          
        })
      }

      return events;
    },

    column(value) {
      return Math.round(value.length * 1.5)
    },

    noData(job) {
      if (job == null) {
        return false
      }

      if (job.length == 0) {
        return false
      }
      return true
    },

  }
};
</script>

<style scoped>
.portal-deep-blue-bg {
  height: 35px;
  color: #fff;
  padding-top: 3px;
}

.title2 {
  background-color: #adf3df;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 12px;
}

.title {
  background-color: #adf3df;
  margin-bottom: 10px;
  font-weight: 200;
  font-size: 12px;
}

.line {
  padding-bottom: 10px;
  padding-top: 0px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 12px;
}

.bold {
  font-weight: 200;
}

.end {
  margin-bottom: 10px;
}

.noData {
  color: red !important;
}

.border-inf {
  border-bottom: 2px solid;
  margin-bottom: 3px;
}

/* Exemple de styles pour vos items */
.timeline-item {
  padding: 12px;
  background: #f0f9ff;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  min-width: 65px;
  height: 100%;
}

.timeline-item time {
  display: block;
  font-size: 0.8em;
  color: #888;
  padding: 12px;
  width: 50px;
}

.horizontal-timeline__list {
  display: flex;
  flex-wrap: nowrap;
  width: max-content; /* largeur = somme des items */
}

/* 3. Chaque item ne rapetisse pas */
.horizontal-timeline__item {
  flex: 0 0 auto;
  height: inherit;
  margin-right: 16px; /* espacement entre items */
}
</style>
